import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useBulkSlip } from '../context/BulkSlipContext';
import { useBulkSlipWtsp } from '../context/BulkSlipWtspContext';

// ⚠️ Update these to match your actual router paths
const SMS_ROUTE = '/bulk_send_preview';
const WTSP_ROUTE = '/wtsp_bulk_slip_send';

const FloatingBulkSlipWidget = () => {
    const { campaign: smsCampaign } = useBulkSlip();
    const { campaign: wtspCampaign } = useBulkSlipWtsp();
    const navigate = useNavigate();
    const location = useLocation();

    const showSms = smsCampaign && smsCampaign.isSending && location.pathname !== SMS_ROUTE;
    const showWtsp = wtspCampaign && wtspCampaign.isSending && location.pathname !== WTSP_ROUTE;

    if (!showSms && !showWtsp) return null;

    const handleSmsClick = () => {
        navigate(SMS_ROUTE, {
            state: {
                booth_no: smsCampaign.boothNo,
                voters: smsCampaign.voters,
                type: smsCampaign.type
            }
        });
    };

    const handleWtspClick = () => {
        navigate(WTSP_ROUTE, {
            state: {
                booth_no: wtspCampaign.boothNo,
                voters: wtspCampaign.voters
            }
        });
    };

    const widgetStyle = (bottomOffset) => ({
        position: 'fixed',
        bottom: `${bottomOffset}px`,
        right: '26px',
        zIndex: 9999,
        color: '#fff',
        borderRadius: '50px',
        padding: '14px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        cursor: 'pointer',
        fontFamily: 'sans-serif',
        fontWeight: 700,
        fontSize: '13px'
    });

    return (
        <>
            {showSms && (
                <div
                    onClick={handleSmsClick}
                    style={{
                        ...widgetStyle(showWtsp ? 92 : 26),
                        background: 'linear-gradient(135deg, #10b981, #059669)',
                        boxShadow: '0 10px 30px rgba(16,185,129,0.4)'
                    }}
                >
                    <span style={dotStyle} />
                    <span>SMS Sending... {smsCampaign.sentCount}/{smsCampaign.totalVoters}
                        {' '}({((smsCampaign.sentCount / smsCampaign.totalVoters) * 100 || 0).toFixed(0)}%)
                    </span>
                </div>
            )}

            {showWtsp && (
                <div
                    onClick={handleWtspClick}
                    style={{
                        ...widgetStyle(26),
                        background: 'linear-gradient(135deg, #25D366, #128C7E)',
                        boxShadow: '0 10px 30px rgba(37,211,102,0.4)'
                    }}
                >
                    <span style={dotStyle} />
                    <span>WhatsApp Sending... {wtspCampaign.sentCount}/{wtspCampaign.totalVoters}
                        {' '}({((wtspCampaign.sentCount / wtspCampaign.totalVoters) * 100 || 0).toFixed(0)}%)
                    </span>
                </div>
            )}

            <style>{`
                @keyframes bulkSlipPulseDot {
                    0% { box-shadow: 0 0 0 0 rgba(255,255,255,0.6);}
                    70% { box-shadow: 0 0 0 8px rgba(255,255,255,0);}
                    100% { box-shadow: 0 0 0 0 rgba(255,255,255,0);}
                }
            `}</style>
        </>
    );
};

const dotStyle = {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: '#fff',
    animation: 'bulkSlipPulseDot 1.4s infinite'
};

export default FloatingBulkSlipWidget;